import _ from 'lodash';
import {generateGuid} from '@packages/utilities/guid';
import type {Context} from '../types';

export default (context: Context) => {
  const {
    node: {jsonNode},
    tree: {nodeMap},
    fn: {insertNodesAfter},
  } = context;
  const {type, children = []} = jsonNode;
  const needed =
    type === 'CommerceCartItemInfo' &&
    !_.find(children, (childId) => {
      const childNode = nodeMap.get(childId);
      return childNode && childNode.type === 'CommerceCartOptionList';
    });

  return {
    needed,
    logData: {
      msg: 'Option List element should be added to every item in the cart',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      const commerceCartOptionListId = generateGuid();
      const commerceCartOptionListItemId = generateGuid();
      const commerceCartOptionListItemLabelId = generateGuid();
      const commerceCartOptionListItemValueId = generateGuid();

      const optionListNode = [
        {
          _id: commerceCartOptionListId,
          type: 'CommerceCartOptionList',
          tag: 'ul',
          children: [commerceCartOptionListItemId],
        },
        {
          _id: commerceCartOptionListItemId,
          type: 'CommerceCartOptionListItem',
          tag: 'li',
          children: [
            commerceCartOptionListItemLabelId,
            commerceCartOptionListItemValueId,
          ],
        },
        {
          _id: commerceCartOptionListItemLabelId,
          type: 'CommerceCartOptionListItemLabel',
          tag: 'span',
        },
        {
          _id: commerceCartOptionListItemValueId,
          type: 'CommerceCartOptionListItemValue',
          tag: 'span',
        },
      ];

      _.each(children, (childId, index) => {
        const childNode = nodeMap.get(childId);
        if (childNode && childNode.type === 'CommerceCartRemoveLink') {
          children.splice(index + 1, 0, commerceCartOptionListId);
          insertNodesAfter(childId, optionListNode);
        }
      });
    },
  };
};
